import { Navigate } from "react-router-dom";

const AppRoute = ({ layout: Layout, component: Component, auth, requiredAccess, ...rest }) => {
  const isAuthenticated = auth !== "no";

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredAccess) {
    let userScope = {};
    try {
      userScope = JSON.parse(localStorage.getItem("scope") || "{}");
    } catch {
      userScope = {};
    }

    if (!userScope?.access?.[requiredAccess]) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return (
    <Layout>
      <Component {...rest} />
    </Layout>
  );
};

export default AppRoute;
